

import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

export default function FinalCTA() {
  return (
    <section className="py-24 bg-primary text-white text-center">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl sm:text-5xl font-bold mb-6">
            Help your teams help each other
          </h2>
          <p className="text-xl text-gray-300 mb-12 max-w-2xl mx-auto">
            See how Ianos removes the friction between wanting to help and getting it right.
          </p>

          <a
            href="https://app.ianos.io"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 bg-accent hover:bg-accent-dark text-white text-lg font-bold px-10 py-5 rounded-xl transition-all transform hover:scale-105 shadow-lg shadow-blue-900/50"
          >
            Request a Demo
            <ArrowRight size={20} />
          </a>
        </motion.div>
      </div>
    </section>
  );
}
